import { env } from "../environments/env";
export const ENV = env.REACT_APP_TOOLS_ENV;

export const PROVIDER = env.REACT_APP_PROVIDER;
export const APP_ID = env.REACT_APP_APP_ID;
export const APP_KEY = env.REACT_APP_APP_KEY;

export const URL = env.REACT_APP_API_URL;
export const URL_SUPPORT = env.REACT_APP_API_URL_SUPPORT;
export const URL_DESVIACION = env.REACT_APP_API_URL_DESVIACION;
export const URL_PROVIDER = env.REACT_APP_API_PROVIDER;
export const URL_LIO = env.REACT_APP_API_URL_LIO;
export const API = env.REACT_APP_API_AUDIT;
export const API_AUDITORIA = env.REACT_APP_API_AUDIT;

export const REACT_APP_AWS_REGION = env.REACT_APP_AWS_REGION;
export const REACT_APP_AWS_USER_POOL = env.REACT_APP_AWS_USER_POOL;
export const REACT_APP_AWS_POOL_WEB_CLIENTID = env.REACT_APP_AWS_POOL_WEB_CLIENTID;
export const REACT_APP_AWS_COGNITO_DOMAIN = env.REACT_APP_AWS_COGNITO_DOMAIN;
export const REACT_APP_AWS_COGNITO_REDIRECTSIGNIN = env.REACT_APP_AWS_COGNITO_REDIRECTSIGNIN;
export const REACT_APP_AWS_COGNITO_REDIRECTSIGNOUT = env.REACT_APP_AWS_COGNITO_REDIRECTSIGNOUT;

export const INTERNAL_EMAIL_DOMAINS = env.REACT_APP_INTERNAL_EMAIL_DOMAINS;

export const API_ADMIN_LISTAS = "/api/admin/adminlistas";
export const API_ADMIN_USER = "/api/admin/user";
export const API_VPP = "/api/admin/vicepresidencia";
export const API_ADMIN_AUDITORIA = "/api/admin/auditoria";

export const API_ADMIN_GERENCIA = "/api/admin/gerencia";

export const API_ADMIN_UNIDAD = "/api/admin/unidad";

export const API_CONTRATO = "/api/admin/contrato";

export const API_ADMIN_CONTRATISTA_SUBCONTRATISTA = "/api/admin/contratistasubcontratista";

export const API_ADMIN_CONTRATISTA_RESPONSABLE = "/api/admin/contratistaresponsable";

export const API_ADMIN_REQ_NORMATIVOS = "/api/admin/requisitosnormativos";

export const API_ADMIN_NOTIFICACIONES = "/api/admin/notificaciones";

export const API_ADMIN_GRAVEDAD_POTENCIAL = "/api/admin/gravedadpotencial";

export const API_ADMIN_AMBITO_DESVIACION = "/api/admin/ambitodesviacion";

export const API_ADMIN_TIPO_DESVIACION = "/api/admin/tipodesviacion";

export const API_ADMIN_ACTO_CONDICION_SUBESTANDAR = "/api/admin/actocondicionsubestandar";

export const API_ADMIN_CAPACIDADES = "/api/admin/capacidades";

export const API_ADMIN_FACTORES_PERSONALES = "/api/admin/factorespersonales";

export const API_ADMIN_REQUISITOS_SISTEMA = "/api/admin/requisitosistema";

export const API_ADMIN_PAGINACION = "/api/admin/paginacion";

export const ROW_COUNT = 10;

export const ROW_COUNT_MAX = 10000000;

export const API_ADMIN_TIPO_CAUSA_INMEDIATA = "/api/admin/tipocausainmediata";

export const API_ADMIN_TIPO_CAUSA_BASICA = "/api/admin/tipocausabasica";

export const API_USERS = "/api/admin/user";

export const API_ROLES = "/api/admin/roles";

export const API_ROLES_USERS = "/api/admin/rolesusuario";

export const API_MODULOS = "/api/admin/modulo";

export const API_ADMIN_TIPO_AUDITORIA = "/api/admin/tipoauditoria";

export const API_ADMIN_AGENTES_CAUSANTES = "/api/admin/agentescausantes";

export const API_ADMIN_EFECTOS = "/api/admin/efectos";

export const API_ADMIN_NATURALEZA_LESIONES = "/api/admin/naturalezalesiones";

export const API_ADMIN_PARTE_CUERPO_LESIONADO = "/api/admin/partecuerpolesionado";

export const API_ADMIN_TIPO_CONTACTO = "/api/admin/tipocontacto";

export const API_ADMIN_TIPO_UNIDAD_AUDITAR = "/api/admin/tipounidadauditar";

export const API_ADMIN_TIPO_ALCANCE = "/api/admin/tipoalcance";

export const API_ADMIN_TIPO_INCIDENTES = "/api/admin/tipoincidentes";

export const API_ADMIN_TIPO_INCIDENTE_USUARIO = "/api/admin/tipoincidenteusuario";

export const API_ADMIN_REQUISITOS = "/api/admin/requisitos";

export const API_ADMIN_ASPECTO = "/api/admin/aspecto";

export const API_ADMIN_CLASIFICACION = "/api/admin/clasificacion";

export const API_ADMIN_TIPIFICACION_INCIDENTE = "/api/admin/tipificacionincidente";

export const API_ADMIN_AREA_RESPONSABLE = "/api/admin/arearesponsable";

export const API_ADMIN_PARAMETROS = "/api/admin/parametros";

export const API_ADMIN_TIPO_PROCESO = "/api/admin/tipoproceso";

export const API_ADMIN_PRODUCTO = "/api/admin/producto";

export const API_ADMIN_PROVEEDOR = "/api/admin/proveedor";

export const API_ADMIN_TIPO_PROVEEDOR = "/api/admin/tipoproveedor";

export const API_ADMIN_TIPO_FAENA = "/api/admin/tipofaena";

export const API_ADMIN_FAENA = "/api/admin/faena";

export const API_ADMIN_TIPO_EVALUACION = "/api/admin/tipoevaluacion";

export const API_ADMIN_ESTADO_DESVIACION = "/api/admin/estadodesviacion";

export const API_ADMIN_ESTADO_CAUSA = "/api/admin/estadocausa";

export const API_ADMIN_DESVIACION = "/api/admin/desviacion";

export const API_ADMIN_LIO_INSPECTOR_TRANSELEC = "/api/admin/lioinspectortranselec";

export const API_ADMIN_LIO_PREVENCIONISTA = "/api/admin/lioprevencionista";

export const API_ADMIN_ARBOL_CAUSAL = "/api/admin/arbol";

export const API_ADMIN_MANTENEDOR_INCIDENTES = "/api/admin/incidente";

export const API_ADMIN_MANTENEDOR_INCIDENTE_CAUSA = "/api/admin/incidentecausa";

export const API_ADMIN_ESTADO_INCIDENTE = "/api/admin/estadoincidente";

export const API_ADMIN_MANTENEDOR_AUDITORIA = "/api/admin/auditoria/mantenedorauditoria";

export const API_ADMIN_MANTENEDOR_ITEM_NORMATIVA = "/api/admin/auditoria/mantenedoritemnormativa";

export const API_ADMIN_ESTADO_AUDITORIA = "/api/admin/EstadoAuditoria";

export const API_ADMIN_MANTENEDOR_IO = "/api/admin/LIOInspeccionObservacion";

export const APP_ADMIN_MANTENEDOR_IO_ASPECTO_EVALUAR = "/api/admin/LIOAspectoEvaluar";

export const API_ADMIN_MANTENEDOR_IO_ESTADO_ASPECTO_EVALUAR = "/api/admin/LIOEstadoAspectoEvaluar";

export const API_ADMIN_ESTADO_INSPECCION = "/api/admin/LIOEstadoInspeccionObservacion";

export const API_ADMIN_MANTENEDOR_PROGRAMAS_ANUALES = "/api/admin/Proveedor";

export const API_ADMIN_LOG_MANTENEDOR = "/api/admin/LogMantenedor";

export const API_ADMIN_GETALLREGISTROSMODIFICADOS = "/api/admin/LogMantenedor";

export const API_ADMIN_MANTENEDOR_PLANIFICACION = "/api/admin/Proveedor/GetAllMantenedorPlanificacion";

export const API_ADMIN_MANTENEDOR_MEDIDA = "/api/admin/Proveedor";

export const API_ADMIN_ESTADO_PROGRAMA = "/api/admin/EstadoPrograma";

export const API_ADMIN_ESTADO_PLANIFICACION = "/api/admin/EstadoPlanificacion";

export const API_ADMIN_ESTADO_MEDIDA = "/api/admin/EstadoMedida/";

export const API_AUDITORIA_GETALL_PROGRAMASAUDITORIAS = "/api/Audit/GetAllProgramasDeAuditoria";

export const API_AUDITORIA_POST_PROGRAMASAUDITORIAS = "/api/Audit/PostProgramaAuditoria";

export const API_AUDITORIA_GET_PROGRAMAAUDITORIA = "/api/Audit/GetProgramaAuditoria";

export const API_AUDITORIA_GETALL_PLANESAUDITORIAS = "/api/Audit/GetAllPlanesDeAuditoria";

export const API_AUDITORIA_GET_TIPOALCANCE_AUDITORIA = "/api/Audit/GetTipoAlcancexAuditoria";

export const API_AUDITORIA_GET_ITEMNORMATIVA_AUDITORIA = "/api/Audit/GetItemNormativaxAuditoria";

export const API_AUDITORIA_GET_AUDITORIA = "/api/Audit";

export const API_AUDITORIA_POST_AUDITORIA = "/api/Audit/PostAuditoria";

export const API_AUDITORIA_POST_AUDITORIA_APROBARPROGRAMAAUDITORIA = "/api/Audit/PostAprobarProgramaAuditoria";

export const API_AUDITORIA_POST_AUDITORIA_APROBARAUDITORIA = "/api/Audit/PostAprobarAuditoria";

export const API_AUDITORIA_GET_REPORTESABANAAUDITORIA = "/api/Audit/GetReporteSabanaAuditoria";

export const API_AUDITORIA_POST_ITEMNORMATIVO = "/api/Audit/PostItemNormativo";

export const API_AUDITORIA_DELETE_ITEMNORMATIVO = "/api/Audit/DeleteItemNormativo";

export const API_AUDITORIA_POST_HALLAZGOS = "/api/Audit/PostHallazgo";

export const API_AUDITORIA_GET_HALLAZGOSXITEMNORMATIVA = "/api/Audit/GetHallazgosxItemNormativa";

export const API_AUDITORIA_DELETE_HALLAZGO = "/api/Audit/DeleteHallazgo";

export const API_AUDITORIA_GET_HALLAZGOSXAUDITORIA = "/api/Audit/GetHallazgosxAuditoria";

export const API_AUDITORIA_GET_DOCUMENTOSAUDITORIA = "/api/Audit/GetDocumentosAuditoria";

export const API_AUDITORIA_DELETE_DOCUMENTOSAUDITORIA = "/api/Audit/DeleteDocumentoAuditoria";

export const API_AUDITORIA_POST_DOCUMENTOSAUDITORIA = "/api/Audit/PostDocumentoAuditoria";

export const API_AUDITORIA_GET_VALIDATIONEXISTHALLAZGOXITEMNORMATIVA = "/api/Audit/GetValidationExistHallazgoxItemNormativa";

export const API_AUDITORIA_POST_VALIDARAUDITORIA = "/api/Audit/PostValidarAuditoria";

export const API_AUDITORIA_POST_RECHAZARAUDITORIA = "/api/Audit/PostRechazarAuditoria";

export const API_AUDITORIA_POST_GENERARPDFPROGRAMAANUAL = "/api/Audit/GenerarPDFProgramaAnual";

export const API_AUDITORIA_POST_GENERARPDFPLAN = "/api/Audit/GenerarPDFPlan";

export const API_AUDITORIA_POST_GENERARPDFINFORME = "/api/Audit/GenerarPDFInforme";

export const API_AUDITORIA_GET_CONTENIDODOCUMENTOAUDITORIA = "/api/Audit/GetContenidoDocumentoAuditoria";

export const API_AUDITORIA_GETALL_HISTORICOPROGRAMASAUDITORIAS = "/api/Audit/GetAllProgramasDeAuditoriaHistorico";

export const API_AUDITORIA_GETALL_HISTORICOPLANESAUDITORIA = "/api/Audit/GetAllPlanesDeAuditoriaHistorico";

export const API_AUDITORIA_GETBLOB_GETEXCELALLPLANESHISTORICO = "/api/Audit/GetExcelAllPlanesDeAuditoriaHistorico";

export const API_AUDITORIA_GETBLOB_GETEXCELREPORTESABANA = "/api/Audit/GetExcelReporteSabana";

export const API_DESVIACION_GET_CALCULODESVIACIONES = "/api/Deviation/GetCalculoDesviaciones";

export const API_DESVIACION_GET_DOCUMENTOSDESVIACION = "/api/Deviation/GetDocumentosDesviacion";

export const API_DESVIACION_POST_DOCUMENTODESVIACION = "/api/Deviation/PostDocumentoDesviacion";

export const API_DESVIACION_DELETE_DOCUMENTODESVIACION = "/api/Deviation/DeleteDocumentoDesviacion";

export const API_DESVIACION_POST_ENVIARDESVIACION = "/api/Deviation/PostEnviarDesviacion";

export const API_DESVIACION_POST_INGRESODESVIACION = "/api/Deviation/PostIngresoDesviacion";

export const API_DESVIACION_GET_LISTADODESVIACIONESHOME = "/api/Deviation/GetListadoDesviacionesHome";

export const API_DESVIACION_GET_LISTADOCAUSASHOME = "/api/Deviation/GetListadoCausasHome";

export const API_DESVIACION_GET_CONTENIDODOCUMENTODESVIACION = "/api/Deviation/GetContenidoDocumentoDesviacion";

export const API_DESVIACION_GET_DESVIACION = "/api/Deviation/GetDesviacion";

export const API_DESVIACION_GET_CAUSASBASICASXDESVIACION = "/api/Deviation/GetCausasBasicasxDesviacion";

export const API_DESVIACION_GET_CAUSASINMEDIATASXDESVIACION = "/api/Deviation/GetCausasInmediatasxDesviacion";

export const API_DESVIACION_GET_CAUSASSISTEMAXDESVIACION = "/api/Deviation/GetCausasSistemaxDesviacion";

export const API_DESVIACION_GET_TIPOSCAUSABASICA = "/api/Deviation/GetTiposCausaBasica";

export const API_DESVIACION_GET_FACTORESPERSONALES = "/api/Deviation/GetFactoresPersonales";

export const API_DESVIACION_GET_CAPACIDADES = "/api/Deviation/GetCapacidades";

export const API_DESVIACION_POST_CAUSABASICA = "/api/Deviation/PostCausaBasica";

export const API_DESVIACION_POST_CAUSAINMEDIATA = "/api/Deviation/PostCausaInmediata";

export const API_DESVIACION_POST_CAUSASISTEMA = "/api/Deviation/PostCausaSistema";

export const API_DESVIACION_GET_CONTENIDODOCUMENTOANALISISCAUSAL = "/api/Deviation/GetContenidoDocumentoAnalisisCausal";

export const API_DESVIACION_DELETE_DOCUMENTOANALISISCAUSAL = "/api/Deviation/DeleteDocumentoArbolCausal";

export const API_DESVIACION_POST_DOCUMENTOANALISISCAUSAL = "/api/Deviation/PostDocumentoArbolCausal";

export const API_DESVIACION_GET_DOCUMENTOSANALISISCAUSAL = "/api/Deviation/GetDocumentosArbolCausal";

export const API_DESVIACION_DELETE_CAUSABASICA = "/api/Deviation/DeleteCausaBasica";

export const API_DESVIACION_DELETE_CAUSASISTEMA = "/api/Deviation/DeleteCausaSistema";

export const API_DESVIACION_DELETE_CAUSAINMEDIATA = "/api/Deviation/DeleteCausaInmediata";

export const API_DESVIACION_GET_TIPOREQUISITOSISTEMA = "/api/Deviation/GetTipoRequisitoSistema";

export const API_DESVIACION_GET_DESCRIPCIONREQUISITO = "/api/Deviation/GetDescripcionRequisito";

export const API_DESVIACION_GET_TIPOSCAUSAINMEDIATA = "/api/Deviation/GetTiposCausaInmediata";

export const API_DESVIACION_GET_ACTOCONDICIONSUBESTANDAR = "/api/Deviation/GetActoCondicionSubestandar";

export const API_DESVIACION_POST_GUARDARARBOLCAUSAL = "/api/Deviation/PostGuardarArbolCausal";

export const API_DESVIACION_GET_DOCUMENTOSCAUSASEVIDENCIAS = "/api/Deviation/GetDocumentosCausasEvidencias";

export const API_DESVIACION_GET_CONTENIDODOCUMENTOSCAUSASEVIDENCIAS = "/api/Deviation/GetContenidoDocumentoCausasEvidencias";

export const API_DESVIACION_POST_GUARDARACCIONCAUSABASICA = "/api/Deviation/PostGuardarAccionCausaBasica";

export const API_DESVIACION_POST_GUARDARACCIONCAUSAINMEDIATA = "/api/Deviation/PostGuardarAccionCausaInmediata";

export const API_DESVIACION_POST_GUARDARACCIONCAUSASISTEMA = "/api/Deviation/PostGuardarAccionCausaSistema";

export const API_DESVIACION_POST_REGISTRARCIERRE = "/api/Deviation/PostCerrarDesviacion";

export const API_DESVIACION_DELETE_DOCUMENTOCAUSASEVIDENCIAS = "/api/Deviation/DeleteDocumentoCausasEvidencias";

export const API_DESVIACION_POST_DOCUMENTOCAUSASEVIDENCIAS = "/api/Deviation/PostDocumentoCausasEvidencias";

export const API_DESVIACION_POST_ACCIONCIERRECAUSABASICA = "/api/Deviation/PostGuardarAccionCierreCausaBasica";

export const API_DESVIACION_POST_ACCIONCIERRECAUSAINMEDIATA = "/api/Deviation/PostGuardarAccionCierreCausaInmediata";

export const API_DESVIACION_POST_ACCIONCIERRECAUSASISTEMA = "/api/Deviation/PostGuardarAccionCierreCausaSistema";

export const API_DESVIACION_POST_DOCUMENTOPLANACCION = "/api/Deviation/PostDocumentoPlanAccion";

export const API_DESVIACION_GET_DOCUMENTOSPLANACCION = "/api/Deviation/GetDocumentosPlanAccion";

export const API_DESVIACION_DELETE_DOCUMENTOPLANACCION = "/api/Deviation/DeleteDocumentoPlanAccion";

export const API_DESVIACION_GET_LISTADOHISTORICO = "/api/Deviation/GetListadoHistoricoDesviaciones";

export const API_DESVIACION_GET_REPORTEDESVIACIONES = "/api/Deviation/GetReporteDesviaciones";

export const API_DESVIACION_GET_REPORTEACCB = "/api/Deviation/GetReporteACCausasBasicas";

export const API_DESVIACION_GET_REPORTESACCI = "/api/Deviation/GetReporteACCausasInmediatas";

export const API_DESVIACION_GET_REPORTESACCS = "/api/Deviation/GetReporteACCausasSistema";

export const API_DESVIACION_GET_REPORTESABANA = "/api/Deviation/GetReporteSabanaDesviaciones";

export const API_DESVIACION_GET_EXCELREPORTEDESVIACIONES = "/api/Deviation/GetExcelReporteDesviaciones";

export const API_DESVIACION_GET_EXCELHISTORICODESVIACIONES = "/api/Deviation/GetExcelReporteHistoricoDesviaciones";

export const API_DESVIACION_GET_EXCELREPORTEAC = "/api/Deviation/GetExcelReporteAnalisisCausal";

export const API_DESVIACION_GET_EXCELREPORTESABANA = "/api/Deviation/GetExcelReporteSabanaDesviaciones";

export const API_PROVEEDOR_GET_PLANIFICACIONES = "/api/Provider";
// LIO

export const API_LIO_GET_CALCULOLIO = "/api/Lio/GetCalculoLIO";

export const API_LIO_GET_LISTADOLIOHOME = "/api/Lio/GetListadoLIOHome";

export const API_LIO_GET_LISTADOASIGNADASHOME = "/api/Lio/GetListadoAsignadasHome";

export const API_LIO_GET_LISTADOASPECTOSINSOBS = "/api/Lio/GetListadoAspectosInsObs";

export const API_LIO_POST_INSPECCIONOBSERVACION = "/api/Lio/PostInspeccionObservacion";

export const API_LIO_POST_DOCUMENTOLIO = "/api/Lio/PostDocumentoInspeccionObservacion";

export const API_LIO_GET_DOCUMENTOSLIO = "/api/Lio/GetDocumentosInspeccionObservacion";

export const API_LIO_DELETE_DOCUMENTOLIO = "/api/Lio/DeleteDocumentoInspeccionObservacion";

export const API_LIO_GET_LIO = "/api/Lio/GetById";

export const API_LIO_POST_ENVIARLIO = "/api/Lio/PostEnviarLIO";

export const API_LIO_GET_ASPECTO_EVALUAR = "/api/Lio/GetAspectoEvaluarById";

export const API_LIO_GET_DOCUMENTOSLIOASPECTOEVALUAR = "/api/Lio/GetDocumentosAspectosEvaluar";

export const API_LIO_POST_DOCUMENTOSLIOASPECTOEVALUAR = "/api/Lio/PostDocumentoAspectoAsignado";

export const API_LIO_POST_SETASPECTOEVALUAR = "/api/Lio/SetAspectoEvaluar";

export const API_LIO_DELETE_DOCUMENTOLIOASPECTOEVALUAR = "/api/Lio/DeleteDocumentoAspectosEvaluar";

export const API_LIO_GET_LISTADOASPECTOSASIGNADOSINSOBS = "/api/Lio/GetListadoAspectosAsignadosInsObs";

export const API_LIO_POST_CERRARASPECTOEVALUADO = "/api/Lio/PostCerrarAspectoEvaluado";

export const API_LIO_GET_LISTADOLIOHISTORICO = "/api/Lio/GetListadoLIOHistorico";

export const API_LIO_GET_LISTADOREPORTELIO = "/api/Lio/GetListadoReporteLIO";

export const API_LIO_GET_LISTADOREPORTESABANA = "/api/Lio/GetListadoReporteSabanaLIO";

export const API_LIO_GET_GESTIONARLIO = "/api/Lio/GetGestionLIO";

export const API_LIO_GET_EXCELHISTORICO = "/api/Lio/GetExcelHistorico";

export const API_LIO_GET_EXCELREPORTELIO = "/api/Lio/GetExcelReporteLIO";

export const API_LIO_GET_EXCELREPORTESABANALIO = "/api/Lio/GetExcelReporteSabanaLIO";

export const API_DESVIACION_POST_DESACTIVARDESVIACION = "/api/Deviation/DesactivarDesviacion";

export const API_DESVIACION_POST_ELIMINARDESVIACION = "/api/Deviation/EliminarDesviacion";

export const API_DESVIACION_POST_DESACTIVARCAUSADESVIACION = "/api/Deviation/DesactivarCausaDesviacion";

export const API_DESVIACION_POST_ELIMINARCAUSADESVIACION = "/api/Deviation/EliminarCausaDesviacion";

export const API_DESVIACION_POST_DESACTIVARLIO = "/api/Lio/DesactivarLIO";

export const API_DESVIACION_DELETE_ELIMINARLIO = "/api/Lio/EliminarLIO";

export const API_DESVIACION_POST_DESACTIVARLIOASPECTO = "/api/Lio/DesactivarLIOAspecto";

export const API_DESVIACION_DELETE_ELIMINARLIOASPECTO = "/api/Lio/EliminarLIOAspecto";

export const API_DESVIACION_POST_DESACTIVARAUDITORIA = "/api/Audit/DesactivarAuditoria";

export const API_DESVIACION_DELETE_ELIMINARAUDITORIA = "/api/Audit/EliminarAuditoria";

export const API_DESVIACION_POST_DESACTIVARAUDITORIAIN = "/api/Audit/DesactivarAuditoriaIN";

export const API_DESVIACION_DELETE_ELIMINARAUDITORIAIN = "/api/Audit/EliminarAuditoriaIN";

export const API_PROVIDER_POST_DESACTIVARPROGRAMAANUAL = "/api/Provider/DesactivarProgramaAnual";

export const API_PROVIDER_POST_DESACTIVARPLANIFICACION = "/api/Provider/DesactivarPlanificacion";

export const API_PROVIDER_POST_DESACTIVARMEDIDA = "/api/Provider/DesactivarMedida";

export const API_PROVIDER_POST_ELIMINARPROGRAMAANUAL = "/api/Provider/EliminarProgramaAnual";

export const API_PROVIDER_POST_ELIMINARPLANIFICACION = "/api/Provider/EliminarPlanificaciones";

export const API_PROVIDER_POST_ELIMINARMEDIDA = "/api/Provider/EliminarMedida";

export const API_PROVIDER_POST_GENERARPDFPLANIFICACION = "/api/Provider/GenerarPDFPlanificacion";

export const API_LIO_GET_LISTADO_REPORTE_ETAPAS_DECISIONES = "/api/Lio/GetListadoReporteEtapasDecisionesLIO";

export const API_LIO_GET_EXCEL_REPORTE_ETAPAS_DECISIONES_LIO = "/api/Lio/GetExcelReporteEtapasDecisionesLIO";
